import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://snap4me.up.railway.app";


/*
 * ============================================================
 * GET JOB DETAIL
 * ============================================================
 *
 * Backend:
 * GET /api/job-detail/{jobId}
 *
 * Example:
 * GET /api/job-detail/25612
 *
 * The backend uses X-User-ID to apply the same access rules as
 * Job Map.
 */
export const getJobDetail = async (jobId) => {
  try {
    if (!jobId) {
      throw new Error("Job ID is required.");
    }

    const storedUser =
      localStorage.getItem("user") ||
      localStorage.getItem("localUser");

    const user = storedUser
      ? JSON.parse(storedUser)
      : null;

    const userId = user?.id;

    if (!userId) {
      throw new Error(
        "Logged-in user ID not found. Please login again."
      );
    }

    const url =
      `${API_BASE_URL}/api/job-detail/${encodeURIComponent(jobId)}`;

    console.log("[JOB DETAIL] Calling API...");
    console.log("[JOB DETAIL] Job ID:", jobId);
    console.log("[JOB DETAIL] User ID:", userId);
    console.log("[JOB DETAIL] URL:", url);

    const response = await axios.get(url, {
      headers: {
        "X-User-ID": String(userId),
      },
      credentials: "include",
    });

    console.log(
      "[JOB DETAIL] API RESPONSE:",
      response.data
    );

    // Backend returns:
    // { success: true, data: {...} }
    //
    // Returning data directly keeps JobDetail.js simple.
    return response.data?.data || response.data;

  } catch (error) {
    console.error(
      "[JOB DETAIL SERVICE ERROR]",
      error.response?.status,
      error.response?.data || error.message
    );

    const message =
      error.response?.data?.detail ||
      error.response?.data?.message ||
      error.message ||
      "Failed to load job detail.";

    const normalizedError = new Error(message);
    normalizedError.status = error.response?.status;
    normalizedError.response = error.response;

    throw normalizedError;
  }
};
